import { Verdict } from '@exam-room/graphql/preview';
import { useTranslation } from '@exam-room/translations';
import { cn } from '@exam-room/utils';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { CheckOutlinedIcon, ClearOutlinedIcon, Form } from '../../../../components';
import { useReviewResult } from '../../../../providers';

export default function VerdictForm() {
  const { t } = useTranslation();

  const { verdict, reviewQuestion } = useReviewResult();

  const verdictFormContext = useForm({
    defaultValues: { verdict: '' },
    mode: 'onChange',
  });

  useEffect(() => {
    verdictFormContext.reset({ verdict: verdict.data ?? '' });
  }, [verdict.data, verdictFormContext]);

  const verdictOnSubmit = verdictFormContext.handleSubmit((data) => {
    if (!data.verdict) return;

    reviewQuestion(data.verdict as Verdict);
  });

  return (
    <div className='flex w-full flex-col items-start gap-2'>
      <div className='text-text-primary block text-sm font-semibold'>
        {t('examPreview.reviewResultSection.reviewResult')} <span className='text-red-500'>*</span>
      </div>
      <form
        onChange={verdictOnSubmit}
        onSubmit={verdictOnSubmit}
        className='flex w-full flex-row gap-3'
      >
        <FormProvider {...verdictFormContext}>
          {/* Agree option */}
          <div className='flex w-full max-w-[200px] gap-2'>
            <div className='relative flex-1'>
              <Form.Radio
                id='verdict-agree'
                name='verdict'
                value={Verdict.Approved}
                className='border'
              >
                {(isChecked) => (
                  <div className={cn('flex w-full items-center justify-between gap-4')}>
                    <div className='flex gap-2'>
                      <CheckOutlinedIcon className='text-text-primary' />
                      {t('examPreview.reviewResultSection.agree')}
                    </div>
                    <div
                      className={cn(
                        'ignore-font-scale flex aspect-square h-5 w-5 items-center justify-center rounded-full border-2 border-gray-400 text-center',
                        isChecked && 'border-primary text-primary',
                      )}
                    >
                      {isChecked ? <div className='bg-primary size-2.5 rounded-full' /> : null}
                    </div>
                  </div>
                )}
              </Form.Radio>
            </div>
          </div>
          {/* Disagree option */}
          <div className='flex w-full max-w-[200px] gap-2'>
            <div className='relative flex-1'>
              <Form.Radio
                id='verdict-disagree'
                name='verdict'
                value={Verdict.Rejected}
                className='border'
              >
                {(isChecked) => (
                  <div className={cn('flex w-full items-center justify-between gap-4')}>
                    <div className='flex gap-2'>
                      <ClearOutlinedIcon className='text-text-primary' />
                      {t('examPreview.reviewResultSection.disagree')}
                    </div>
                    <div
                      className={cn(
                        'ignore-font-scale flex aspect-square h-5 w-5 items-center justify-center rounded-full border-2 border-gray-400 text-center',
                        isChecked && 'border-primary text-primary',
                      )}
                    >
                      {isChecked ? <div className='bg-primary size-2.5 rounded-full' /> : null}
                    </div>
                  </div>
                )}
              </Form.Radio>
            </div>
          </div>
        </FormProvider>
      </form>
    </div>
  );
}
